var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex mb-4"},[_c('div',{staticClass:"filtered-property"},[_vm._t("default"),(_vm.showIndicator)?_c('FilterIndicator'):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }